<div class="container-fluid">

  <form [formGroup]="detailForm">

    <div *showIfDebugMode class="row">

      <div class="col-3 flex">
        <mat-form-field class="w-100">
          <mat-label>Id</mat-label>
          <input id="id" matInput formControlName="id">
        </mat-form-field>
      </div>

    </div>

    <div class="row">

      <div class="col-3">
        <mat-form-field class="w-100">
          <mat-label>{{ 'ID' | translate }}</mat-label>
          <input id="id" matInput formControlName="id">
        </mat-form-field>
      </div>

      <div class="col-3">
        <mat-form-field class="w-100">
          <mat-label>{{ 'CREATED_ON' | translate }}</mat-label>
          <input id="createdOn" matInput formControlName="createdOn">
        </mat-form-field>
      </div>

      <div class="col-3">
        <mat-form-field class="w-100">
          <mat-label>{{ 'TRANSACTION.CODE' | translate }}</mat-label>
          <input id="transactionTypeCode" matInput formControlName="transactionTypeCode">
        </mat-form-field>
      </div>

      <div class="col-3">
        <mat-form-field class="w-100">
          <mat-label>{{ 'TRANSACTION.TYPE' | translate }}</mat-label>
          <input id="transactionTypeName" matInput formControlName="transactionTypeName">
        </mat-form-field>
      </div>

    </div>

    <div class="row">

      <div class="col-3">
        <mat-form-field class="w-100">
          <mat-label>{{ 'FROM' | translate }} {{ 'LOCATION.LOCATION_ID' | translate }}</mat-label>
          <input id="fromLocationId" matInput formControlName="fromLocationId">
        </mat-form-field>
      </div>

      <div class="col-3">
        <mat-form-field class="w-100">
          <mat-label>{{ 'FROM' | translate }} {{ 'LOCATION.LOCATION' | translate }} {{ 'NAME' | translate }} 1</mat-label>
          <input id="fromName1" matInput formControlName="fromLocationName1">
        </mat-form-field>
      </div>

      <div class="col-3">
        <mat-form-field class="w-100">
          <mat-label>{{ 'FROM' | translate }} {{ 'LOCATION.LOCATION' | translate }} {{ 'NAME' | translate }} 2</mat-label>
          <input id="fromName2" matInput formControlName="fromLocationName2">
        </mat-form-field>
      </div>

      <div class="col-3">
        <mat-form-field class="w-100">
          <mat-label>{{ 'FROM' | translate }} {{ 'ADDRESS_TYPE' | translate }}</mat-label>
          <input id="fromLocationType" matInput formControlName="fromLocationType">
        </mat-form-field>
      </div>

    </div>

    <div class="row">

      <div class="col-3">
        <mat-form-field class="w-100">
          <mat-label>{{ 'TO' | translate }}  {{ 'LOCATION.LOCATION_ID' | translate }}</mat-label>
          <input id="toLocationId" matInput formControlName="toLocationId">
        </mat-form-field>
      </div>

      <div class="col-3">
        <mat-form-field class="w-100">
          <mat-label>{{ 'TO' | translate }} {{ 'LOCATION.LOCATION' | translate }} {{ 'NAME' | translate }} 1</mat-label>
          <input id="toName1" matInput formControlName="toLocationName1">
        </mat-form-field>
      </div>

      <div class="col-3">
        <mat-form-field class="w-100">
          <mat-label>{{ 'TO' | translate }} {{ 'LOCATION.LOCATION' | translate }} {{ 'NAME' | translate }} 2</mat-label>
          <input id="toName2" matInput formControlName="toLocationName2">
        </mat-form-field>
      </div>

      <div class="col-3">
        <mat-form-field class="w-100">
          <mat-label>{{ 'TO' | translate }} {{ 'ADDRESS_TYPE' | translate }}</mat-label>
          <input id="toLocationType" matInput formControlName="toLocationType">
        </mat-form-field>
      </div>

    </div>

    <div class="row">

      <div class="col-3">
        <mat-form-field class="w-100">
          <mat-label>{{ 'MOBILE_LOCATION.MOBILE_LOCATION_ID' | translate }}</mat-label>
          <input id="toMovedId" matInput formControlName="movedLocationId">
        </mat-form-field>
      </div>

      <div class="col-3">
        <mat-form-field class="w-100">
          <mat-label>{{ 'MOBILE_LOCATION.MOBILE_LOCATION' | translate }} {{ 'NAME' | translate }} 1</mat-label>
          <input id="toMovedName1" matInput formControlName="movedLocationName1">
        </mat-form-field>
      </div>

      <div class="col-3">
        <mat-form-field class="w-100">
          <mat-label>{{ 'MOBILE_LOCATION.MOBILE_LOCATION' | translate }} {{ 'NAME' | translate }} 2</mat-label>
          <input id="toMovedName2" matInput formControlName="movedLocationName2">
        </mat-form-field>
      </div>

      <div class="col-3">
        <mat-form-field class="w-100">
          <mat-label>{{ 'MOBILE_LOCATION.MOBILE_LOCATION' | translate }} {{ 'ADDRESS_TYPE' | translate }}</mat-label>
          <input id="toMovedLocationType" matInput formControlName="movedLocationType">
        </mat-form-field>
      </div>

    </div>

    <div class="row">

      <div class="col-3">
        <mat-form-field class="w-100">
          <mat-label>{{ 'FROM' | translate }} {{ 'PROJECT.PROJECT_ID' | translate }}</mat-label>
          <input id="fromProjectId" matInput formControlName="fromProjectId">
        </mat-form-field>
      </div>

      <div class="col-3">
        <mat-form-field class="w-100">
          <mat-label>{{ 'FROM' | translate }} {{ 'PROJECT.PROJECT' | translate }}</mat-label>
          <input id="fromProjectName" matInput formControlName="fromProjectName">
        </mat-form-field>
      </div>

    </div>

    <div class="row">

      <div class="col-3">
        <mat-form-field class="w-100">
          <mat-label>{{ 'TO' | translate }} {{ 'PROJECT.PROJECT_ID' | translate }}</mat-label>
          <input id="toProjectId" matInput formControlName="toProjectId">
        </mat-form-field>
      </div>

      <div class="col-3">
        <mat-form-field class="w-100">
          <mat-label>{{ 'TO' | translate }} {{ 'PROJECT.PROJECT' | translate }}</mat-label>
          <input id="toProjectName" matInput formControlName="toProjectName">
        </mat-form-field>
      </div>

    </div>

  </form>
</div>
